import * as yup from 'yup';
import { FieldValidator } from '../../types';
import { MAX_DESCRIPTION_LENGTH } from '../../constants';

export const validator: FieldValidator = (ctx, t) =>
  yup.object({
    descriptionState: yup
      .object()
      .test(
        'editor-max-length',
        t('deviationSubmit.validation.error.description.tooLong'),
        value => {
          // Might not have a value if it's a legacy description, in which case we skip validation
          if (!value) {
            return true;
          }
          if (typeof value === 'function') {
            const v = value();
            if (v) {
              // We use half because html and feature are included in the limit
              return v.length < MAX_DESCRIPTION_LENGTH / 2;
            }
          }
          return true;
        }
      ),
  });
